import BookLocation from '../BookLocation';
import UserContentItem from '../UserContentItem';

// Shared logic for all user content items that have location properties.
class UserContentItemWithLocation extends UserContentItem {
  bookLocation;

  constructor(properties = {}) {
    super(...arguments);

    this.bookLocation = new BookLocation({
      book: properties.book,
      document: properties.document,
      documentIndex: properties.documentIndex,
      cfi: properties.cfi,
      page: properties.page,
      pageIndex: properties.pageIndex,
      marker: properties.marker,
      markerIndex: properties.markerIndex,
    });
  }

  serialize() {
    const { documentIndex, pageIndex, markerIndex, cfi } = this.bookLocation;

    return {
      ...super.serialize(),

      documentIndex,
      pageIndex,
      markerIndex,
      cfi,
    };
  }

  get document() {
    return this.bookLocation.document;
  }

  get marker() {
    return this.bookLocation.marker;
  }

  get topLevelMarker() {
    return this.bookLocation.topLevelMarker;
  }

  get page() {
    return this.bookLocation.page;
  }

  get cfi() {
    return this.bookLocation.cfi;
  }

  get locationPropertiesForGraphQL() {
    return {
      epubId: this.book.pk,
      cfi: this.bookLocation.cfi,
      epubPageIndex: this.bookLocation.page?.index,
      spineEntryIndex: this.bookLocation.document.index,
      ncxEntryIndex: this.bookLocation.marker?.index,
    };
  }
}

export default UserContentItemWithLocation;
